var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurfaceTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4388 13.8542C15.4388 14.9472 14.5527 15.8333 13.4596 15.8333C12.3666 15.8333 11.4805 14.9472 11.4805 13.8542C11.4805 12.7611 12.3666 11.875 13.4596 11.875C14.5527 11.875 15.4388 12.7611 15.4388 13.8542Z",
    stroke: "#003371",
    strokeWidth: 1.1875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52083 13.8542C7.52083 14.9472 6.63473 15.8333 5.54167 15.8333C4.4486 15.8333 3.5625 14.9472 3.5625 13.8542C3.5625 12.7611 4.4486 11.875 5.54167 11.875C6.63473 11.875 7.52083 12.7611 7.52083 13.8542Z",
    stroke: "#003371",
    strokeWidth: 1.1875
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4779 13.854H7.51953M15.4362 13.854H16.0404C16.2145 13.854 16.3016 13.854 16.3747 13.8449C16.9142 13.7777 17.339 13.3528 17.4063 12.8134C17.4154 12.7402 17.4154 12.6531 17.4154 12.479V10.2915C17.4154 7.44954 15.1115 5.14567 12.2695 5.14567M11.8737 12.2707V5.5415C11.8737 4.42192 11.8737 3.86213 11.5259 3.51431C11.1781 3.1665 10.6183 3.1665 9.4987 3.1665H3.95703C2.83745 3.1665 2.27765 3.1665 1.92984 3.51431C1.58203 3.86213 1.58203 4.42192 1.58203 5.5415V11.8748C1.58203 12.6147 1.58203 12.9847 1.74112 13.2603C1.84535 13.4408 1.99526 13.5907 2.17578 13.6949C2.45134 13.854 2.82129 13.854 3.5612 13.854",
    stroke: "#003371",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14453 5.5415V8.70801M8.3112 5.5415V8.70801",
    stroke: "#003371",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurfaceTruck);
export default __webpack_public_path__ + "static/media/surface-truck.1ef78adfc856fc1bea232610c1c28408.svg";
export { ForwardRef as ReactComponent };